import { render } from "@/components/pages/dataRecollection/dtc/DtcPage.html?vue&type=template&id=23b0e59e&external"
import script from "@/components/pages/dataRecollection/dtc/DtcPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/dtc/DtcPage.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__